export const ORDER_TYPE_ORDER = 'order'
export const ORDER_TYPE_BUDGET = 'budget'
